import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import { loadingStatus } from "actions"
import _ from "lodash"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import { toast } from "react-toastify"
import Modal from "react-responsive-modal"
import settings from "settings"
import * as Yup from "yup"
import Dropzone from "react-dropzone"
import * as FileSaver from "file-saver"

class MassLotUpdate extends Component {
	constructor(props) {
		super(props)

		this.state = {
			ready: false,
			filename: "",
			modalTemplateGenerator: false,
			generatorErrorText: false,
			fields: {
				property: 0,
				neighborhood: 0,
				lot_type: 0,
				mud: null,
				lid: null,
				isd: null,
			},
		}

		this.generator = React.createRef()
	}

	validation = () => {
		return Yup.object().shape({})
	}

	onDrop = (files, f, k) => {
		//console.log(files, data)
		//console.log(this.props)
		//return
		this.props.loadingStatus(true)
		const req = request.post(`${settings.ep}/inputMassLotUpdate`)
		req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.end((err, response) => {
			//return
			let resp = response.body

			if (err) {
				console.log(err)
				toast.error(resp.message)
			}
			if (resp.status == 200) {
				toast.success(resp.message)
				f.setFieldValue("filename", resp.filename)
				this.setState({ ready: true, filename: resp.filename })
			}
			this.props.loadingStatus(false)
		})
	}

	propertyLimited = (f, name) => {
		let ret = []
		_.forEach(this.props.payload.public[name], (v) => {
			if (v.property == f.values.property) {
				ret.push({
					label: v.name,
					value: v.id,
				})
			}
		})
		return ret
	}

	options = (name) => {
		let opts = []
		_.forEach(this.props.payload.public[name], (v) => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

	submitClasses(f) {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f && this.state.ready,
		})

		return submitClasses
	}

	buildSiteIDs = () => {
		let sites = _.map(this.props.payload.public.sites, (v) => (
			<li>
				{v.name}: {v.id}
			</li>
		))
		return <ul className="styled">{sites}</ul>
	}

	render() {
		if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<Title title="Mass Lot Update" showDate={false} />
					<div className="content">
						<div className="flex justify-end">
							<div
								className="btn"
								onClick={() => {
									this.setState({ modalTemplateGenerator: true })
								}}>
								Template Generator
							</div>
						</div>
						<ul className="list">
							<li>
								To Download the template,{" "}
								<a href={`${settings.s3}/lot-import/lot-update-template.csv?v=${Date.now()}`}>
									CLICK HERE
								</a>
							</li>
							<li>Column Heads must not be changed. If you don't need all columns, leave them blank.</li>
							Use ID numbers for these fields:
							<ul>
								<li>
									ID (Column A "ID" is the only REQUIRED field and will link your data to the correct
									lot/block/section). Export the section from Lot Management for easy reference. The
									column labeled Lot ID from lot management will be the ID.
								</li>
								<li>Builder</li>
								<li>Lot Type</li>
								<li>Site ID</li>
								<li>Neighborhood</li>
								<li>ISD</li>
								<li>LID</li>
								<li>MUD</li>
							</ul>
							<li>
								Enter the data into the template. Dates may be formatted either 1/1/2020 or 01/01/2020.
								Do not format values, e.g. $75,000 would be entered as 75000. Save as .csv file.
							</li>
							<li>
								<strong>CHECK your data BEFORE uploading it.</strong>
							</li>
						</ul>
						<Formik
							enableReinitialize
							initialValues={this.state.fields}
							validationSchema={this.validation}
							onSubmit={(values, actions) => {
								this.props.loadingStatus(true)
								submitData("massLotUpdate", values).then((data) => {
									//return
									this.props.loadingStatus(false)
									toast.success(data.message)
									actions.resetForm()
									this.setState({ ready: false, filename: "" })
									//return
								})
							}}
							render={(f) => (
								<div className="editCommunity">
									<Form>
										{/*console.log(f)*/}
										<ul className="form__list">
											<li className={fieldStatus("files", f, false, false, false)}>
												<label htmlFor="files">
													Excel File <sup>*</sup>
												</label>
												{f.errors.files && f.touched.files && (
													<div className="form__message">{f.errors.files}</div>
												)}
												{!this.state.ready && (
													<Dropzone
														multiple={false}
														onDrop={(files) => {
															this.onDrop(files, f)
														}}>
														{({ getRootProps, getInputProps }) => (
															<section className="dropzone">
																<div {...getRootProps()} className="dropbox__cont">
																	<input {...getInputProps()} />
																	<p className="dropzone__action">
																		Drag 'n' drop file here, or click to select
																		files
																	</p>
																</div>
															</section>
														)}
													</Dropzone>
												)}
												{this.state.ready && (
													<p style={{ color: "green" }}>Spreadsheet has been uploaded.</p>
												)}
											</li>
										</ul>
										<input
											type="submit"
											value={this.state.ready ? "Ready for Upload" : "Not Ready for Upload"}
											className={this.submitClasses(f.isValid)}
										/>
									</Form>
									<h3 style={{ marginTop: 50 }}>Site ID Numbers</h3>
									{this.buildSiteIDs()}
								</div>
							)}
						/>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.modalTemplateGenerator}
							onClose={() => this.setState({ modalTemplateGenerator: false })}
							center>
							<h2>Template Generator</h2>
							<p className="mt-4 text-sm">
								This generator will attempt to create a template for you based on the addresses pasted
								into the box. One address per line. If an address cannot be found, the template will not
								be created and an error will attempt to notify you which lot does not exist.
							</p>
							<p className="text-green-800 font-bold">Please paste one address per line below:</p>
							{this.state.generatorErrorText ? (
								<p className="text-red-500">{this.state.generatorErrorText}</p>
							) : (
								""
							)}
							<textarea ref={this.generator} className="w-full h-64 mt-4"></textarea>
							<button
								type="button"
								className="btn"
								onClick={() => {
									let addresses = this.generator.current.value
									if (addresses.length > 0) {
										this.props.loadingStatus(true)
										submitData("generateTemplate", { addresses, property: this.props.activeProperties[0] })
											.then((data) => {
												this.props.loadingStatus(false)
												if (data.status == 200) {
													toast.success(data.message)
													let csv = data.csv.replace(/\\n/g, '\n')
													FileSaver.saveAs(new Blob([csv], { type: "text/csv;charset=utf-8" }), "lot-update-template.csv")
													this.setState({ generatorErrorText: false })
												} else {
													toast.error(data.message)
													this.setState({ generatorErrorText: data.message })
												}
											})
											.catch((e) => {
												toast.error(e.message)
												this.setState({ generatorErrorText: e.message })
											})
									}
									this.props.loadingStatus(false)
								}}>
								Create Template
							</button>
						</Modal>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ loadingStatus }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(MassLotUpdate)
